<template>
  <div class="home-main">
    <Row :gutter="10">
      <Col span="24">
        <Row type="flex" class="user-infor">
          <!-- <Col span="4">
            <Row class-name="made-child-con-middle" type="flex" align="middle">
              <img class="avator-img" :src="avatorPath" />
            </Row>
          </Col> -->
          <Col span="16" style="padding-left: 6px">
            <Row class-name="made-child-con-middle" type="flex" align="middle">
              <div>
                <h3 class="card-user-infor-name" v-if="shopName">
                  {{ shopName }}
                </h3>
                <h3 class="card-user-infor-name" v-if="userName">
                  {{ userName }}
                </h3>
                <p style="margin-top: 10px">
                  上次登录时间:{{ last_login_time || "" }}
                </p>
              </div>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
    <AnalysisSimple v-if="isAdmin"></AnalysisSimple>
    <template>
      <Row v-for="(v, k) in items || []" :key="k">
        <Col span="24">
          <card-header
            :name="v.label"
            :label="v.desc"
            :color="v.color"
          ></card-header>
          <template v-for="(vv, kk) in v.list">
            <card-box
              v-auth="'' + vv.auth"
              :key="kk"
              :name="vv.label"
              :label="vv.desc"
              :url="vv.url"
              :icon="vv.icon"
              :color="vv.color || v.color"
              :hot="vv.hot === true ? 'Hot' : vv.hot ? vv.hot : ''"
            ></card-box>
          </template>
        </Col>
      </Row>
    </template>
  </div>
</template>

<script>
import AnalysisSimple from "@/views/analysis/dashboard/simple";

export default {
  name: "home",
  components: {
    AnalysisSimple: AnalysisSimple,
  },
  data() {
    return {
      simple_info: {},
      items: [
        {
          label: "产品类型",
          desc: "多样化产品介绍",
          color: "#2d8cf0",
          type: "select",
          list: [
            {
              label: "加水",
              desc: "加水管理",
              url: "water_list",
              icon: "md-paper",
              color: "",
              hot: true,
              auth: "/admin/water/lists",
            },
            {
              label: "回声树",
              desc: "回声树管理",
              url: "reverb_list",
              icon: "md-stats",
              color: "",
              hot: true,
              auth: "/admin/reverb/lists",
            },
            {
              label: "兑换",
              desc: "兑换管理",
              url: "commodity_list",
              icon: "md-stats",
              color: "",
              hot: true,
              auth: "/admin/commodity/lists",
            },
            // {
            //   label: "用户",
            //   desc: "用户管理",
            //   url: "user_list",
            //   icon: "md-stats",
            //   color: "",
            //   hot: true,
            //   auth: "/admin/user/lists",
            // },
            // {
            //   label: "轮播",
            //   desc: "轮播管理",
            //   url: "banner_list",
            //   icon: "md-stats",
            //   color: "",
            //   hot: true,
            //   auth: "/admin/banner/lists",
            // },
            // { label: '景点', desc: '景点管理', url: 'spot_list', icon: 'md-cube', color: '', hot: true, auth: '/admin/spot/lists' },
            // { label: '故事', desc: '故事管理', url: 'thing_list', icon: 'ios-list-box', color: '', hot: true, auth: '/admin/thing/lists' },
            // { label: '商家', desc: '商家管理', url: 'shop_list', icon: 'md-paper', color: '', hot: true, auth: '/admin/shop/lists' },
            // { label: '美食', desc: '美食管理', url: 'dish_list', icon: 'md-stats', color: '', hot: true, auth: '/admin/dish/lists' },
            // { label: '食谱', desc: '食谱管理', url: 'cookbook_list', icon: 'md-pie', color: '', hot: true, auth: '/admin/cookbook/lists' },
            // { label: '文章', desc: '文章管理', url: 'article_list', icon: 'md-cube', color: '', hot: true, auth: '/admin/article/lists' },
          ],
        },
      ],
    };
  },
  computed: {
    userName() {
      return $utils.data.get("auth", "uname") || "";
    },
    shopName() {
      return $utils.data.get("auth", "shop_name") || "";
    },
    avatorPath() {
      return $utils.data.get("auth", "avatar");
    },
    last_login_time() {
      return $utils.data.get("auth", "last_login_time") || "";
    },
    isSystem() {
      return $utils.data.get("auth", "is_system") || false;
    },
    isAdmin() {
      return $utils.data.get("auth", "is_admin") || false;
    },
    isShop() {
      return $utils.data.get("auth", "is_shop") || false;
    },
  },
  created() {},
  methods: {},
};
</script>
<style lang="less">
@import "../../styles/common.less";

.user-infor {
  height: 135px;
}
.avator-img {
  display: block;
  width: 80%;
  max-width: 100px;
  height: auto;
}
.card-user-infor-name {
  font-size: 1.5em;
  color: #2d8cf0;
}
.card-title {
  color: #abafbd;
}
.made-child-con-middle {
  height: 100%;
}
</style>
